import React from "react";
import { useNavigate } from "react-router-dom";
import logo from "../assets/imgs/logo.png";
import { api } from "../utils/api";
import "./Dashboard/Dashboard.css";

const Header = () => {
  const navigate = useNavigate();
  const userName = localStorage.getItem("user_name") || "Admin User";

  const handleLogout = async () => {
    localStorage.clear();
    navigate("/");
    // try {
    //   await api.logout();
    // } catch (error) {
    //   console.error("Logout API call failed:", error);
    // } finally {
    //   localStorage.clear();
    //   navigate("/");
    // }
  };

  return (
    <header className="dashboard-header">
      <div className="header-content">
        <div className="header-left">
          <div className="logo-container">
            <img
              src={logo}
              alt="Safe City Survey Portal Logo"
              className="logo"
            />
            <div className="header-text">
              <h1>Islamabad Safe City Survey Portal</h1>
              <p>Dashboard</p>
            </div>
          </div>
        </div>
        <div className="header-right">
          <div className="user-info">
            <span className="user-name">{ userName }</span>
            <button
              onClick={handleLogout}
              className="btn btn-secondary logout-btn"
            >
              Logout
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
